import { createSelector } from "@reduxjs/toolkit";
import { _route_, clearPathFromParams, getBaseLang, getPrimaryLang } from "@nxplatform/helpers/helpers-pure";
import { Sections, EventStatus } from "@nxplatform/platform-entities/sport/common-sport.entities";
var OuterMenuSport = /* @__PURE__ */ ((OuterMenuSport2) => {
  OuterMenuSport2["sportLine"] = "sportLine";
  OuterMenuSport2["sportLive"] = "sportLive";
  OuterMenuSport2["leagues"] = "sportLeagues";
  OuterMenuSport2["leaguePage"] = "leaguePage";
  OuterMenuSport2["multiLeaguePage"] = "multiLeaguesPage";
  OuterMenuSport2["forecast"] = "toto";
  OuterMenuSport2["results"] = "result";
  OuterMenuSport2["eventFull"] = "eventFull";
  OuterMenuSport2["eventFullSpecial"] = "eventFullSpecial";
  OuterMenuSport2["search"] = "search";
  OuterMenuSport2["searchAll"] = "searchAll";
  OuterMenuSport2["sportSearch"] = "sportSearch";
  OuterMenuSport2["casinoCategory"] = "casinoCategory";
  OuterMenuSport2["casinoProducer"] = "casinoProducer";
  OuterMenuSport2["casinoCategoryProducer"] = "casinoCategoryProducer";
  OuterMenuSport2["liveCasinoCategory"] = "liveCasinoCategory";
  OuterMenuSport2["liveCasinoProducer"] = "liveCasinoProducer";
  OuterMenuSport2["liveCasinoCategoryProducer"] = "liveCasinoCategoryProducer";
  OuterMenuSport2["casinoGame"] = "casinoGame";
  OuterMenuSport2["casino"] = "casino";
  OuterMenuSport2["liveCasino"] = "liveCasino";
  OuterMenuSport2["outrights"] = "outrights";
  OuterMenuSport2["cabinet"] = "cabinet";
  OuterMenuSport2["promotions"] = "promotions";
  OuterMenuSport2["vipSportPrograms"] = "sportVipPrograms";
  OuterMenuSport2["casinoDemoGame"] = "casinoDemoGame";
  OuterMenuSport2["liveCasinoDemoGame"] = "liveCasinoDemoGame";
  OuterMenuSport2["liveCasinoGame"] = "liveCasinoGame";
  OuterMenuSport2["customSport"] = "customSport";
  OuterMenuSport2["customSportSelected"] = "customSportSelected";
  OuterMenuSport2["customSportLeague"] = "customSportLeague";
  OuterMenuSport2["customSportLeagues"] = "customSportLeagues";
  return OuterMenuSport2;
})(OuterMenuSport || {});
const getAllowedPaths = () => window.paths || [];
const pickRelevantPath = (label, defaultPath) => {
  const path = getAllowedPaths().find((el) => el.label === label);
  if (path) {
    return path.path;
  }
  return defaultPath || "";
};
const cleanLinks = {
  casino: _route_("/casino"),
  liveCricket: _route_("/live/cricket"),
  liveCasino: _route_("/live-casino"),
  casinoCategory: _route_("/casino/:categoryName"),
  casinoProducer: _route_("/casino/all/:producerName"),
  casinoCategoryProducer: _route_("/casino/:categoryName/:producerName"),
  casinoGame: _route_("/casino/game/:producerName/:gameName"),
  casinoDemoGame: _route_("/casino/demo-game/:producerName/:gameName"),
  liveCasinoCategory: _route_("/live-casino/:categoryName"),
  liveCasinoProducer: _route_("/live-casino/all/:producerName"),
  liveCasinoCategoryProducer: _route_("/live-casino/:categoryName/:producerName"),
  liveCasinoGame: _route_("/live-casino/game/:producerName/:gameName"),
  liveCasinoDemoGame: _route_("/live-casino/demo-game/:producerName/:gameName"),
  cabinet: _route_("/cabinet"),
  home: _route_("/"),
  toto: _route_("/forecast"),
  result: _route_("/results"),
  sportLive: _route_("/:stateName/:sportName"),
  sportLine: _route_("/:stateName/:sportName"),
  sportLeagues: _route_("/:stateName/:sportName/leagues"),
  leaguePage: _route_("/:stateName/leagues/:leagueId"),
  multiLeaguesPage: _route_("/:stateName/leagues/list/:leagueIds"),
  outrights: _route_("/:stateName/leagues/:leagueId/:outright"),
  eventFull: _route_("/:stateName/:sportName/:leagueId/:eventId"),
  eventFullSpecial: _route_("/:stateName/special/:customSportName/:leagueId/:eventId"),
  search: _route_("/search/:status/:name"),
  searchAll: _route_("/search/all"),
  sportSearch: _route_("/:stateName/search/:name"),
  deposit: _route_("/cabinet/deposit"),
  withdrawal: _route_("/cabinet/withdrawal"),
  verification: _route_("/cabinet/verification"),
  verificationInfo: _route_("/cabinet/verification/info"),
  transactionHistory: _route_("/cabinet/transaction-history"),
  cabinetPromotion: _route_("/cabinet/promotions"),
  promotionsHistory: _route_("/cabinet/promotions-history"),
  cabinetRewards: _route_("/cabinet/rewards"),
  cabinetCoins: _route_("/cabinet/coins"),
  totoHistory: _route_("/cabinet/forecast-history"),
  profile: _route_("/cabinet/personal-details"),
  betHistory: _route_("/cabinet/betting-history"),
  casinoSessionHistory: _route_("/cabinet/casino-session-history"),
  casinoHistory: _route_("/cabinet/casino-history"),
  accountSettings: _route_("/cabinet/preferences"),
  passwordRestore: _route_("/user/password/edit"),
  userConfirmation: _route_("/user/confirmation"),
  contactUs: _route_("/contacts"),
  terms: _route_("/terms"),
  bettingRules: _route_("/betting-rules"),
  notFound: _route_("/404"),
  promotions: _route_("/promotions"),
  promotionsPage: _route_("/promotions/:name"),
  vipPrograms: _route_("/vip-programs"),
  vipSportPrograms: _route_("/sport-vip-programs"),
  landings: _route_("/promotions/casino"),
  live: _route_("/live"),
  line: _route_("/prematch"),
  prematchESports: _route_("/prematch/eSports"),
  registrationPage: _route_("/registration"),
  registrationPageEsports: _route_("/registration-esports"),
  popanderRegistration: _route_("/registration/pop"),
  hallOfFlame: _route_("/hall-of-flame"),
  hallOfFameCasino: _route_("/hall-of-fame"),
  hallOfFameSport: _route_("/hall-of-fame-sport"),
  payment: _route_("/payments"),
  tournaments: _route_("/tournaments"),
  tournamentPage: _route_("/tournaments/:tournamentId"),
  cabinetOverview: _route_("/cabinet/overview"),
  blockedVerification: _route_("/blocked/verification"),
  cabinetLimits: _route_("/cabinet/my-limits"),
  cabinetLimitsType: _route_("/cabinet/my-limits/:type/:id"),
  cabinetLimitsNewType: _route_("/cabinet/my-limits/:type"),
  responsibleGamblingLimits: _route_("/cabinet/limits"),
  responsibleGamblingExclusion: _route_("/cabinet/limits/exclusion"),
  responsibleGamblingDeactivation: _route_("/cabinet/limits/deactivation"),
  responsibleGamblingCoolingOff: _route_("/cabinet/cooling-off"),
  bettorsTournament: _route_("/bettors-tournament"),
  aviatorGame: _route_("/casino/game/spribe/aviator"),
  crashGame: _route_("/casino/game/bgaming/SpaceXY"),
  fastGames: _route_("/casino/fast-games"),
  lastPlayed: _route_("/casino/last-played"),
  lastPlayedLive: _route_("/live-casino/last-played"),
  fishingAndHunting: _route_("/casino/fishing"),
  virtualSport: _route_("/casino/virtual-sport"),
  recommended: _route_("/casino/recommended"),
  liveCasinoRecommended: _route_("/live-casino/recommended"),
  recommendedCategory: _route_("/casino/recommended/:categoryName"),
  liveCasinoRecommendedCategory: _route_("/live-casino/recommended/:categoryName"),
  mobileApp: _route_("/mobile-app"),
  elements: _route_("/elements"),
  paymentIQTestDeposit: _route_("/cabinet/deposit-payment"),
  paymentIQTestWithdrawal: _route_("/cabinet/withdrawal-payment"),
  registrationMigration: _route_("/registration/migration"),
  registrationMigrationGvive: _route_("/verification/migration"),
  horseRacing: _route_("/racing"),
  security: _route_("/cabinet/security"),
  cabinetReferrals: _route_("/cabinet/referrals"),
  referrals: _route_("/referrals"),
  eParkstsAuth: _route_("/lvrtc/oauth/authorization-code-back"),
  statistics: _route_("/cabinet/statistics"),
  bonusPackage: _route_("/bonus-package/*"),
  reportsAndMessages: _route_("/cabinet/reports-and-messages"),
  favoritesLive: _route_("/live/favorites"),
  favoritesLine: _route_("/prematch/favorites"),
  boostedOdds: _route_("/boosted"),
  incomingBets: _route_("/incoming-bets"),
  deepLink: _route_("/deep-link"),
  sharedCoupon: _route_("/shared-coupon"),
  reports: _route_("/cabinet/reports"),
  sportPage: _route_("/sport"),
  wheelOfFortune: _route_("/promotions/wheel-of-fortune"),
  customSport: _route_("/:stateName/special/:customSportName"),
  customSportLeague: _route_("/:stateName/special/:customSportName/leagues/:leagueId"),
  customSportLeagues: _route_("/:stateName/special/:customSportName/leagues/list/:leagueIds"),
  customSportSelected: _route_("/:stateName/special/:customSportName/:innerSport")
};
const parseLink = (cleanLink, language) => language === getPrimaryLang() ? `${cleanLink}` : `/${(language || "").toLowerCase()}${cleanLink === cleanLinks.home ? "" : cleanLink}`;
const playGameLinks = [
  clearPathFromParams(cleanLinks.casinoGame),
  clearPathFromParams(cleanLinks.casinoDemoGame),
  clearPathFromParams(cleanLinks.liveCasinoGame),
  clearPathFromParams(cleanLinks.liveCasinoDemoGame)
];
const gameExitPath = "game/exit";
const urlLang = getBaseLang();
const sportLinks = {
  live: parseLink(cleanLinks.live, urlLang),
  line: parseLink(cleanLinks.line, urlLang),
  sportLive: parseLink(cleanLinks.sportLive, urlLang),
  sportLine: parseLink(cleanLinks.sportLine, urlLang),
  sportLeagues: parseLink(cleanLinks.sportLeagues, urlLang),
  leaguePage: parseLink(cleanLinks.leaguePage, urlLang),
  multiLeaguesPage: parseLink(cleanLinks.multiLeaguesPage, urlLang),
  eventFull: parseLink(cleanLinks.eventFull, urlLang),
  eventFullSpecial: parseLink(cleanLinks.eventFullSpecial, urlLang),
  outrights: parseLink(cleanLinks.outrights, urlLang),
  toto: parseLink(cleanLinks.toto, urlLang),
  result: parseLink(cleanLinks.result, urlLang),
  search: parseLink(cleanLinks.search, urlLang),
  searchAll: parseLink(cleanLinks.searchAll, urlLang),
  sportSearch: parseLink(cleanLinks.sportSearch, urlLang),
  favoritesLive: parseLink(cleanLinks.favoritesLive, urlLang),
  favoritesLine: parseLink(cleanLinks.favoritesLine, urlLang),
  boostedOdds: parseLink(cleanLinks.boostedOdds, urlLang),
  incomingBets: parseLink(cleanLinks.incomingBets, urlLang),
  customSport: parseLink(cleanLinks.customSport, urlLang),
  customSportLeague: parseLink(cleanLinks.customSportLeague, urlLang),
  customSportLeagues: parseLink(cleanLinks.customSportLeagues, urlLang),
  customSportSelected: parseLink(cleanLinks.customSportSelected, urlLang)
};
const casinoLinks = {
  casino: parseLink(cleanLinks.casino, urlLang),
  liveCasino: parseLink(cleanLinks.liveCasino, urlLang),
  casinoCategory: parseLink(cleanLinks.casinoCategory, urlLang),
  casinoProducer: parseLink(cleanLinks.casinoProducer, urlLang),
  casinoCategoryProducer: parseLink(cleanLinks.casinoCategoryProducer, urlLang),
  casinoGame: parseLink(cleanLinks.casinoGame, urlLang),
  casinoDemoGame: parseLink(cleanLinks.casinoDemoGame, urlLang),
  liveCasinoCategory: parseLink(cleanLinks.liveCasinoCategory, urlLang),
  liveCasinoProducer: parseLink(cleanLinks.liveCasinoProducer, urlLang),
  liveCasinoCategoryProducer: parseLink(cleanLinks.liveCasinoCategoryProducer, urlLang),
  liveCasinoGame: parseLink(cleanLinks.liveCasinoGame, urlLang),
  liveCasinoDemoGame: parseLink(cleanLinks.liveCasinoDemoGame, urlLang),
  aviatorGame: parseLink(cleanLinks.aviatorGame, urlLang),
  crashGame: parseLink(cleanLinks.crashGame, urlLang),
  fastGames: parseLink(cleanLinks.fastGames, urlLang),
  lastPlayed: parseLink(cleanLinks.lastPlayed, urlLang),
  lastPlayedLive: parseLink(cleanLinks.lastPlayedLive, urlLang),
  cabinetReferrals: parseLink(cleanLinks.cabinetReferrals, urlLang),
  referrals: parseLink(cleanLinks.referrals, urlLang),
  fishingAndHunting: parseLink(cleanLinks.fishingAndHunting, urlLang),
  virtualSport: parseLink(cleanLinks.virtualSport, urlLang),
  recommended: parseLink(cleanLinks.recommended, urlLang),
  liveCasinoRecommended: parseLink(cleanLinks.liveCasinoRecommended, urlLang),
  recommendedCategory: parseLink(cleanLinks.recommendedCategory, urlLang),
  liveCasinoRecommendedCategory: parseLink(cleanLinks.liveCasinoRecommendedCategory, urlLang)
};
const outerLinks = {
  hallOfFlame: parseLink(cleanLinks.hallOfFlame, urlLang),
  hallOfFameCasino: parseLink(cleanLinks.hallOfFameCasino, urlLang),
  hallOfFameSport: parseLink(cleanLinks.hallOfFameSport, urlLang),
  promotionsPage: parseLink(cleanLinks.promotionsPage, urlLang),
  tournaments: parseLink(cleanLinks.tournaments, urlLang),
  tournamentPage: parseLink(cleanLinks.tournamentPage, urlLang),
  passwordRestore: parseLink(cleanLinks.passwordRestore, urlLang),
  userConfirmation: parseLink(cleanLinks.userConfirmation, urlLang),
  contactUs: parseLink(
    pickRelevantPath("contacts", cleanLinks.contactUs),
    urlLang
  ),
  terms: parseLink(pickRelevantPath("terms", cleanLinks.terms), urlLang),
  bettingRules: parseLink(cleanLinks.bettingRules, urlLang),
  notFound: parseLink(cleanLinks.notFound, urlLang),
  promotions: parseLink(cleanLinks.promotions, urlLang),
  vipPrograms: parseLink(cleanLinks.vipPrograms, urlLang),
  vipSportPrograms: parseLink(cleanLinks.vipSportPrograms, urlLang),
  landings: parseLink(cleanLinks.landings, urlLang),
  registrationPage: parseLink(cleanLinks.registrationPage, urlLang),
  registrationPageEsports: parseLink(cleanLinks.registrationPageEsports, urlLang),
  popanderRegistration: parseLink(cleanLinks.popanderRegistration, urlLang),
  bettorsTournament: parseLink(cleanLinks.bettorsTournament, urlLang),
  mobileApp: parseLink(cleanLinks.mobileApp, urlLang),
  elements: parseLink(cleanLinks.elements, urlLang),
  bonusPackage: parseLink(cleanLinks.bonusPackage, urlLang),
  reportsAndMessages: parseLink(cleanLinks.reportsAndMessages, urlLang),
  deepLink: parseLink(cleanLinks.deepLink, urlLang)
};
const outerLinksMap = Object.values(outerLinks);
const cabinetLinks = {
  cabinet: parseLink(cleanLinks.cabinet, urlLang),
  deposit: parseLink(cleanLinks.deposit, urlLang),
  withdrawal: parseLink(cleanLinks.withdrawal, urlLang),
  verification: parseLink(cleanLinks.verification, urlLang),
  verificationInfo: parseLink(cleanLinks.verificationInfo, urlLang),
  transactionHistory: parseLink(cleanLinks.transactionHistory, urlLang),
  cabinetPromotion: parseLink(cleanLinks.cabinetPromotion, urlLang),
  promotionsHistory: parseLink(cleanLinks.promotionsHistory, urlLang),
  cabinetRewards: parseLink(cleanLinks.cabinetRewards, urlLang),
  cabinetCoins: parseLink(cleanLinks.cabinetCoins, urlLang),
  totoHistory: parseLink(cleanLinks.totoHistory, urlLang),
  profile: parseLink(cleanLinks.profile, urlLang),
  betHistory: parseLink(cleanLinks.betHistory, urlLang),
  casinoSessionHistory: parseLink(cleanLinks.casinoSessionHistory, urlLang),
  casinoHistory: parseLink(cleanLinks.casinoHistory, urlLang),
  accountSettings: parseLink(cleanLinks.accountSettings, urlLang),
  cabinetOverview: parseLink(cleanLinks.cabinetOverview, urlLang),
  cabinetLimits: parseLink(cleanLinks.cabinetLimits, urlLang),
  cabinetLimitsType: parseLink(cleanLinks.cabinetLimitsType, urlLang),
  cabinetLimitsNewType: parseLink(cleanLinks.cabinetLimitsNewType, urlLang),
  responsibleGamblingLimits: parseLink(cleanLinks.responsibleGamblingLimits, urlLang),
  responsibleGamblingExclusion: parseLink(cleanLinks.responsibleGamblingExclusion, urlLang),
  responsibleGamblingDeactivation: parseLink(cleanLinks.responsibleGamblingDeactivation, urlLang),
  responsibleGamblingCoolingOff: parseLink(cleanLinks.responsibleGamblingCoolingOff, urlLang),
  paymentIQTestDeposit: parseLink(cleanLinks.paymentIQTestDeposit, urlLang),
  paymentIQTestWithdrawal: parseLink(cleanLinks.paymentIQTestWithdrawal, urlLang),
  security: parseLink(cleanLinks.security, urlLang),
  statistics: parseLink(cleanLinks.statistics, urlLang),
  reports: parseLink(cleanLinks.reports, urlLang)
};
const allowedLinksPure = {
  ...sportLinks,
  ...outerLinks,
  ...casinoLinks,
  ...cabinetLinks,
  cricket: parseLink(cleanLinks.liveCricket, urlLang),
  affiliate: "#",
  home: parseLink(cleanLinks.home, urlLang),
  toto: parseLink(cleanLinks.toto, urlLang),
  prematchESports: parseLink(cleanLinks.prematchESports, urlLang),
  blockedVerification: parseLink(cleanLinks.blockedVerification, urlLang),
  registrationMigration: parseLink(cleanLinks.registrationMigration, urlLang),
  registrationMigrationGvive: parseLink(cleanLinks.registrationMigrationGvive, urlLang),
  eParkstsAuth: parseLink(cleanLinks.eParkstsAuth, urlLang),
  horseRacing: parseLink(cleanLinks.horseRacing, urlLang),
  sportPage: parseLink(cleanLinks.sportPage, urlLang),
  sharedCoupon: parseLink(cleanLinks.sharedCoupon, urlLang),
  wheelOfFortune: parseLink(cleanLinks.wheelOfFortune, urlLang)
};
const allowedLinksHandler = {
  get(target, prop) {
    if (prop === "contactUs") {
      return parseLink(
        pickRelevantPath("contacts", cleanLinks.contactUs),
        getBaseLang()
      );
    }
    if (prop === "terms") {
      return parseLink(pickRelevantPath("terms", cleanLinks.terms), getBaseLang());
    }
    return parseLink(cleanLinks[prop], getBaseLang());
  }
};
const allowedLinks = new Proxy(allowedLinksPure, allowedLinksHandler);
const disableSportLinks = [
  allowedLinks.casino,
  allowedLinks.casinoCategory,
  allowedLinks.casinoProducer,
  allowedLinks.liveCasino,
  allowedLinks.liveCasinoProducer,
  allowedLinks.liveCasinoCategory,
  allowedLinks.casinoGame,
  allowedLinks.liveCasinoGame,
  allowedLinks.registrationPage,
  allowedLinks.registrationPageEsports,
  allowedLinks.popanderRegistration,
  allowedLinks.contactUs,
  allowedLinks.cabinetPromotion,
  allowedLinks.cabinet,
  allowedLinks.cabinetCoins,
  allowedLinks.deposit,
  allowedLinks.withdrawal,
  allowedLinks.transactionHistory,
  allowedLinks.verification,
  allowedLinks.totoHistory,
  allowedLinks.betHistory,
  allowedLinks.userConfirmation,
  allowedLinks.passwordRestore,
  allowedLinks.profile,
  allowedLinks.accountSettings,
  allowedLinks.promotions
];
const deepLinks = {
  accountSignin: "sign-in",
  accountSignup: "account/sign-up",
  deposit: "cabinet/deposit"
};
const selectIsCasinoPage = createSelector(
  (pathname) => pathname,
  (pathname) => !!new RegExp(`^.*${allowedLinks.casino}|${allowedLinks.liveCasino}.*$`).exec(pathname)
);
const selectWsSportDisabled = createSelector(
  (pathname) => pathname,
  (pathname) => disableSportLinks.includes(pathname) || selectIsCasinoPage(pathname)
);
const generateLossLimitTypePageUrl = createSelector(
  (type) => type,
  (type, limitId) => `${limitId}`,
  (type, limitId) => allowedLinks.cabinetLimitsType.replace(":type", type).replace(":id", limitId)
);
const generateLossLimitNewTypePageUrl = createSelector(
  (type) => type,
  (type) => allowedLinks.cabinetLimitsNewType.replace(":type", type)
);
const generateSportMenuLink = createSelector(
  (alias) => alias,
  (alias, name) => allowedLinks[name],
  (alias, name, state) => state,
  (alias, name, state) => name.replace(":sportName", alias).replace(":customSportName", alias).replace(":stateName", state)
);
const generateCustomSportInnerMenuLink = createSelector(
  (alias) => alias,
  (alias, name) => allowedLinks[name],
  (alias, name, state) => state,
  (alias, name, state, league) => league,
  (alias, name, state, league) => name.replace(":sportName", alias).replace(":customSportName", alias).replace(":stateName", state)
  // .replace(':leagueId', `${league?.id}-${league?.translationSlug}`), //DEVNOTE: will ad this in future tasks
);
const generateSportMenuStatusLink = createSelector(
  (params) => params,
  (params) => {
    const link = params.section === Sections.live ? allowedLinks.sportLive : allowedLinks.sportLine;
    return link.replace(":sportName", params.alias).replace(":customSportName", params.alias).replace(":stateName", params.section);
  }
);
const generateCasinoCategoryLink = createSelector(
  (params) => params,
  (params) => {
    var _a;
    if ((_a = params.category) == null ? void 0 : _a.length) {
      const category = params.state ? allowedLinks.liveCasinoCategory : allowedLinks.casinoCategory;
      return category.replace(":categoryName", params.category);
    }
    return params.state ? allowedLinks.liveCasino : allowedLinks.casino;
  }
);
const generateRecommendCategoryLink = createSelector(
  (params) => params,
  (params) => {
    var _a;
    if ((_a = params.category) == null ? void 0 : _a.length) {
      const category = params.state ? allowedLinks.liveCasinoRecommendedCategory : allowedLinks.recommendedCategory;
      return category.replace(":categoryName", params.category);
    }
    return params.state ? allowedLinks.liveCasinoRecommendedCategory : allowedLinks.recommendedCategory;
  }
);
const generateCasinoProducerLink = createSelector(
  (params) => params,
  (params) => {
    var _a;
    if (params.isCategory) {
      const producerLink = params.state ? allowedLinks.liveCasinoCategoryProducer : allowedLinks.casinoCategoryProducer;
      return producerLink.replace(":categoryName", params.categorySlug).replace(":producerName", params.producer);
    }
    if ((_a = params.producer) == null ? void 0 : _a.length) {
      const producerLink = params.state ? allowedLinks.liveCasinoProducer : allowedLinks.casinoProducer;
      return producerLink.replace(":producerName", params.producer);
    }
    return params.state ? allowedLinks.liveCasino : allowedLinks.casino;
  }
);
const generateCasinoGameLink = createSelector(
  (params) => params,
  (params) => {
    const link = params.state ? allowedLinks.liveCasinoGame : allowedLinks.casinoGame;
    return link.replace(":producerName", params.producer).replace(":gameName", params.game);
  }
);
const generateCasinoDemoGameLink = createSelector(
  (params) => params,
  (params) => {
    const link = params.state ? allowedLinks.liveCasinoDemoGame : allowedLinks.casinoDemoGame;
    return link.replace(":producerName", params.producer).replace(":gameName", params.game);
  }
);
const generateSportEventLink = createSelector(
  (params) => params,
  (params) => allowedLinks[
    params.isCustomSport ? "eventFullSpecial" : "eventFull"
    /* eventFull */
  ].replace(":sportName", params.alias).replace(":customSportName", params.alias).replace(":stateName", params.state).replace(":leagueId", params.league).replace(":eventId", params.event)
);
const generateEventLink = (sport, league, event, isCustomSport) => generateSportEventLink({
  alias: sport == null ? void 0 : sport.alias,
  league: `${league.id}-${league.translationSlug}`,
  event: `${event.id}-${event.translationSlug}`,
  state: event.status === EventStatus.online ? Sections.live : Sections.line,
  isCustomSport
});
const generateSportMenuLeaguesLink = createSelector(
  (params) => params,
  (alias, name) => allowedLinks[name],
  (alias, name) => name.replace(":stateName", alias.type).replace(":leagueId", alias.league).replace(":customSportName", alias.sport)
);
const generateSportMenuMultiplyLeaguesLink = createSelector(
  (params) => params,
  (alias, name) => allowedLinks[name],
  (alias, name) => name.replace(":stateName", alias.type).replace(":leagueIds", alias.league).replace(":customSportName", alias.sport).replace(":sportName", alias.sport)
);
const generateSportMenuOutrightLink = createSelector(
  (params) => params,
  (alias, name) => allowedLinks[name],
  (alias, name) => name.replace(":stateName", alias.type).replace(":leagueId", alias.league).replace(":outright", `${alias.leagueId}`)
);
const generateLeagueLink = (type, league, sport, isCustom) => generateSportMenuLeaguesLink(
  { type, league: `${league.id}-${league.translationSlug}`, sport },
  isCustom ? "customSportLeague" : "leaguePage"
  /* leaguePage */
);
const generateOutrightLeagueLink = (type, league) => generateSportMenuOutrightLink(
  {
    type,
    league: `${league.id}-${league.translationSlug}`,
    leagueId: league.id
  },
  "outrights"
  /* outrights */
);
const generateSportSectionLink = ({
  sport,
  section,
  league,
  isCustom
}) => {
  const isOutrightLink = (sport == null ? void 0 : sport.countEvents) === 0;
  if (isOutrightLink && league) {
    return generateOutrightLeagueLink(section, league);
  }
  let state;
  if (isCustom) {
    state = "customSport";
  } else {
    state = section === Sections.line ? "sportLine" : "sportLive";
  }
  return generateSportMenuLink(sport.alias, state, section);
};
const generateSearchPageLink = createSelector(
  (params) => params,
  (params) => allowedLinks.search.replace(":name", (params.value || "").toLocaleLowerCase()).replace(":status", (params.status || Sections.all).toLocaleLowerCase())
);
const generateNewSearchPageLink = createSelector(
  (params) => params,
  (params) => allowedLinks.search.replace(":name", (params.value || "").toLocaleLowerCase()).replace(":status", Sections.all.toLocaleLowerCase())
);
const generateLinkPart = createSelector(
  (partName) => allowedLinks[partName],
  (part, exclude) => exclude,
  (part, exclude, section) => section,
  (part, exclude, section) => {
    const excludeUpdated = exclude.reduce((acc, excluded) => {
      const linkChunks = excluded.split("/");
      return [...acc, ...linkChunks];
    }, []);
    return part.split("/").filter((link) => !excludeUpdated.includes(link)).join("/").replace(":stateName", section || "");
  }
);
const handleMatchedLinkPart = createSelector(
  (linkPart) => linkPart,
  (linkPart) => linkPart === "/" ? "" : linkPart
);
const casinoAllowedPages = [
  allowedLinks.casino,
  allowedLinks.liveCasino
];
const cashierPages = [allowedLinks.deposit, allowedLinks.withdrawal];
const disabledPromotionsLinks = [
  allowedLinks.promotions,
  allowedLinks.toto,
  allowedLinks.tournaments
];
const excludedCasinoLinks = [
  allowedLinks.casinoHistory,
  allowedLinks.casino,
  allowedLinks.aviatorGame,
  allowedLinks.crashGame,
  allowedLinks.fastGames,
  allowedLinks.lastPlayed,
  allowedLinks.lastPlayedLive
];
const excludedLiveCasinoLinks = [
  allowedLinks.liveCasino
];
const excludedLimits = [
  allowedLinks.cabinetLimits,
  allowedLinks.cabinetLimitsType,
  allowedLinks.cabinetLimitsNewType
];
const fullScreenPages = [
  ...Object.values(casinoLinks),
  allowedLinks.promotions,
  allowedLinks.vipPrograms,
  allowedLinks.vipSportPrograms,
  allowedLinks.bettorsTournament,
  allowedLinks.landings,
  allowedLinks.notFound,
  allowedLinks.registrationPage,
  allowedLinks.registrationPageEsports,
  allowedLinks.popanderRegistration,
  allowedLinks.hallOfFameCasino,
  allowedLinks.hallOfFameSport,
  allowedLinks.mobileApp,
  allowedLinks.registrationMigration
];
const getCustomAsideRoutes = () => [
  allowedLinks.contactUs,
  allowedLinks.passwordRestore,
  allowedLinks.userConfirmation
];
const selectIsCasinoLivePage = createSelector(
  (path) => path,
  (path) => path.indexOf(allowedLinks.liveCasino) > -1
);
const selectIsFullScreenPage = createSelector(
  (page) => page,
  (page) => fullScreenPages.includes(page)
);
const selectCustomAsidePages = createSelector(
  (page) => page,
  (page) => getCustomAsideRoutes().includes(page)
);
const generatePasswordHomeLink = () => allowedLinks.home;
export {
  OuterMenuSport,
  allowedLinks,
  allowedLinksPure,
  cabinetLinks,
  cashierPages,
  casinoAllowedPages,
  casinoLinks,
  deepLinks,
  disableSportLinks,
  disabledPromotionsLinks,
  excludedCasinoLinks,
  excludedLimits,
  excludedLiveCasinoLinks,
  fullScreenPages,
  gameExitPath,
  generateCasinoCategoryLink,
  generateCasinoDemoGameLink,
  generateCasinoGameLink,
  generateCasinoProducerLink,
  generateCustomSportInnerMenuLink,
  generateEventLink,
  generateLeagueLink,
  generateLinkPart,
  generateLossLimitNewTypePageUrl,
  generateLossLimitTypePageUrl,
  generateNewSearchPageLink,
  generateOutrightLeagueLink,
  generatePasswordHomeLink,
  generateRecommendCategoryLink,
  generateSearchPageLink,
  generateSportEventLink,
  generateSportMenuLeaguesLink,
  generateSportMenuLink,
  generateSportMenuMultiplyLeaguesLink,
  generateSportMenuOutrightLink,
  generateSportMenuStatusLink,
  generateSportSectionLink,
  getCustomAsideRoutes,
  handleMatchedLinkPart,
  outerLinks,
  outerLinksMap,
  parseLink,
  pickRelevantPath,
  playGameLinks,
  selectCustomAsidePages,
  selectIsCasinoLivePage,
  selectIsCasinoPage,
  selectIsFullScreenPage,
  selectWsSportDisabled,
  sportLinks
};
